<template>
  <div class="drug-intruction-detail-item">
    <div class="drug-intruction-detail-item-title">
      {{ title }}
    </div>
    <div class="drug-intruction-detail-item-content">
      <div>
        {{ content }}
      </div>
      <div>
        {{ content2 }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    content2: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less">
.drug-intruction-detail-item {
  margin-top: 0.75rem;
  padding-left: 0.94rem;
  background: white;

  &-title {
    font-weight: 450;
    font-size: 1.06rem;
    line-height: 2.75rem;
    border-bottom: 1px solid #f2f2f2;
  }

  &-content {
    padding: 0.63rem 0;
    color: #333;
    font-size: 0.94rem;
  }
}
</style>
